import { MINIMUM_THRESHOLD_USD } from '~/components/automations/SubmitButton'
import { Group } from '~/components/component-library'

export const MinimumThresholdDisplay = ({
  value = MINIMUM_THRESHOLD_USD,
}: {
  value?: number
}) => (
  <Group
    label="Automatic trigger threshold"
    layout="horizontal"
    tooltip="An automatic run starts when any one token reaches this value. Once it starts, every token worth at least $1 is processed."
  >
    ${value}
  </Group>
)
